import { OSCSettings } from 'ontime-types';

export const oscPlaceholderSettings: OSCSettings = {
  portIn: 8888,
  portOut: 9999,
  targetIP: '127.0.0.1',
  enabledIn: false,
  enabledOut: false,
  subscriptions: [],
};
